import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../utils/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnboardingData,
    setOnboardingData
} from '../../../../redux/onboardingSlice';
import { http_put } from '../../utils/api_client';

const OPTIONS = [
    {
        value: 'walkthrough',
        title: 'Interactive walkthrough',
        desc: 'Guide users click-by-click through your product.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="14" rx="2" /><circle cx="8" cy="11" r="2" /></svg>
        )
    },
    {
        value: 'path',
        title: 'Path',
        desc: 'A multi-step course of walkthroughs and content.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="6" cy="6" r="2" /><circle cx="18" cy="18" r="2" /><path d="M8 6h6a4 4 0 0 1 0 8H10a4 4 0 0 0 0 8" /></svg>
        )
    },
    {
        value: 'checklist',
        title: 'Checklist',
        desc: 'A trackable task list for onboarding or ramp.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3 8-8" /><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9" /></svg>
        )
    },
    {
        value: 'doc',
        title: 'Doc',
        desc: 'A rich help article for your knowledge base.',
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></svg>
        )
    }
];

export const FirstContentTitle = () => (
    <div>
        <h1 className="un-auth__q un-auth__q--sm">What would you like to create first?</h1>
        <p className="un-auth__sub">We'll get your workspace ready for it.</p>
    </div>
);

const FirstContent = ({ onChangeStep }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => getOnboardingData(state));
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const select = (value) => {
        dispatch(setOnboardingData({ primaryGoal: value }));
    };

    const saveData = () => {
        setIsLoading(true);
        setError(null);
        http_put(API_ENDPOINTS.PUT_COMPANY, { primary_goal: data.primaryGoal })
            .then(() => onChangeStep())
            .catch((err) => {
                setError(err?.response?.data?.error || err?.response?.data?.message || 'Something went wrong. Please try again.');
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <div className="un-auth__cards">
                {OPTIONS.map((opt) => (
                    <div
                        key={opt.value}
                        className={`un-auth__card ${data.primaryGoal === opt.value ? 'sel' : ''}`}
                        onClick={() => select(opt.value)}
                    >
                        <div className="un-auth__card-ic">{opt.icon}</div>
                        <div className="un-auth__card-t">{opt.title}</div>
                        <div className="un-auth__card-d">{opt.desc}</div>
                    </div>
                ))}
            </div>
            {error && <p className="un-auth__err" role="alert">{error}</p>}
            <button className="un-auth__btn un-auth__btn--primary" onClick={saveData} disabled={!data.primaryGoal || isLoading}>
                {isLoading ? 'Saving…' : 'Continue'}
            </button>
        </>
    );
};

export default FirstContent;
